module.exports = __webpack_public_path__ + "img/swiper-banner.4cbe928d.png";